import React from 'react'
import Image from 'next/image'
import { TAuthor } from '~shared/api/single-journal-data/types'

type TAuthorBadgeProps = {
  author: TAuthor | undefined
  position?: 'left' | 'right'
  variant?: 'default' | 'homeVideo' | 'programVideo'
}

const variantStyles = {
  default: {
    container: 'flex flex-row items-center gap-[8px]',
    imageContainer: 'relative w-[40px] h-[40px] min-w-[40px]',
    job: 'text-[12px] leading-[120%] text-[var(--omega)]',
    name: 'text-[14px] font-medium leading-[120%]'
  },
  homeVideo: {
    container: 'flex flex-row items-center gap-[8px]',
    imageContainer: 'relative w-[48px] h-[48px] min-w-[48px]',
    job: 'text-[12px] leading-[120%] text-white',
    name: 'text-[16px] font-medium leading-[120%] text-white'
  },
  programVideo: {
    container: 'flex flex-row items-center gap-[8px]',
    imageContainer: 'relative w-[56px] h-[56px] min-w-[56px]',
    job: 'text-[11px] leading-[120%] text-white',
    name: 'text-[14px] font-medium leading-[120%] text-white'
  }
} as const

export const AuthorBadge = ({
  author,
  position,
  variant = 'default'
}: TAuthorBadgeProps) => {
  
  const styles = variantStyles[variant]

  return (
    <div className={`${styles.container} ${position === 'right' ? 'ml-auto' : ''}`}>
      <div className={`${styles.imageContainer} rounded-full overflow-hidden`}>
        <Image
          fill
          src={author?.image?.url || '/'}
          alt=''
          className='object-cover'
        />
      </div>

      {author !== undefined && (
        <div
          className='flex flex-col gap-[4px]'
          itemScope
          itemType='https://schema.org/Person'
        >
          {author?.job && (
            <p className={styles.job} itemProp='jobTitle'>
              {author.job}
            </p>
          )}
          {author?.name && (
            <p className={styles.name} itemProp='name'>
              {author.name}
            </p>
          )}
        </div>
      )}
    </div>
  )
}
